import React, { useCallback, useEffect, useState } from 'react'
import Loader from '../elements/Loader';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import * as moment from 'moment';
import io from 'socket.io-client';
import './SfaChat.scss';
import { useSelector } from 'react-redux';
import { CHAT_API_URL } from '../../../config/constants';
import secureStorage from '../../../config/encrypt';
import { IS_USER_ACCESS_PAGE } from '../../../config/IFConstant';
import { executeGraphQLQuery } from '../../../services/inventory-funding/executeGraphQLQuery';
import { LEAD_DETAIL_QUERY } from '../../../services/inventory-funding/leads.gql';
import { useApolloClient } from '@apollo/client';
import GeneralService from '../../../services/generalService';
import LeadListFilter from './LeadListTopFilter';

const statusList=[
  {label: 'Incomplete' , value:1},
  {label: 'Submitted' , value:2},
  {label: 'Verified' , value:3},
  {label: 'Financier Details' , value:15},
  {label: 'Vehicle Inspection' , value:13},
  {label: 'Collateral Appraised' , value:4},
  {label: 'Credit Ops Approved' , value:5},
  {label: 'Loan Agreement' , value:16},
  {label: 'Resubmission' , value:6},
  {label: 'Rejected' , value:7},
  {label: 'Completed' , value:8}
];

export default function SfaChat(props) {
    const [loading, setLoading] = useState(false);
    const [filterData, setFilterData] = useState({});
    const statusOption = statusList;
    const [pageCount, setPageCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [leadId, setLeadId] = useState(0);
    const [messages, setMessages] = useState('');
    const [messageBox, setMessageBOx] = useState("");
    const [chatdata, setChatdata] = useState([]);
    const [ticketData, setTicketData] = useState({});
    const [socket, setSocket] = useState(null);
    let logInUserInfo = useSelector(({ user }) => user.user_information) || {};
    logInUserInfo = JSON.parse(logInUserInfo);
    const token=secureStorage.getItem("authToken");
    const headers={
      headers: { Authorization: token }
    };
    const client = useApolloClient();
    const [leadDetails, setLeadDetailsData] = useState({});
    // State to track connection status
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
      return () => {
        if (socket) {
          socket.disconnect();
          console.log('Socket disconnected on unmount');
        }
      };
    }, [socket]);
    

    useEffect(()=>{
        getChatList()
    },[])

    async function getChatList(page_num=1,filterData={}){
        setLoading(true);
        const response = await axios.post(`${CHAT_API_URL.CHAT_URL}api/get-all-ticket`, {
            "user_id":logInUserInfo?.id,
            "page_num":page_num,
            "source":"web",
            ...filterData,
        },headers);
        if(response?.data?.data?.length){
            setChatdata(response?.data?.data);
            setPageCount(response?.data?.pagination?.totalrecords)
        }else{
            setChatdata([]);
            setPageCount(0)
        }
        setLoading(false);
    }

    const handlePageClick = (selectedPage) => {
        setPageCount(selectedPage?.selected);
        getChatList(+selectedPage?.selected+1,{...filterData});
    };

    const connectSocket=async (lead_id=0)=>{

        // Disconnect the existing socket if it exists
        if (socket) {
          socket.disconnect();
        }
       // Connect to the Socket.IO server
        const newSocket = io(`${CHAT_API_URL.CHAT_URL}socket`); 
        // Change URL to your server's URL
        newSocket.on('connected', async () => {
          await getLeadDetails(lead_id)
            setIsConnected(true);
            newSocket.emit('joinRoom',{ lead_id: lead_id , user_id : logInUserInfo?.id,source:"web" });
            setLeadId(lead_id);
            newSocket.emit("getChatMessages",{lead_id: lead_id,source: "web"})
            
            console.log('Connected to Socket.IO server!');
        });

        newSocket.on('left-room', async () => {
            console.log('Successfully left in room');
        });

        newSocket.on('joinedRoom', async () => {
          console.log('Successfully Joined in room');
        });

        newSocket.on('disconnected', () => {
            setIsConnected(false);
            newSocket.emit('leaveRoom',{ lead_id: lead_id,user_id:logInUserInfo?.id })
            console.log('Disconnected from Socket.IO server');
        });
        newSocket.on("newMessage",(data)=>{
          console.log("New Message")
            newSocket.emit("getChatMessages",{lead_id: lead_id, page_num:1,source: "web"})
        });

        newSocket.on("chatList",(data)=>{
          console.log("Chat List")
            // let msg=messages;
            setTicketData(data?.chatTicket)
            setMessages(data?.chatData);
            var objDiv = document.getElementById("chat-history");
            objDiv.scrollTop = objDiv.scrollHeight;

        })
        // Save socket instance in the state
        setSocket(newSocket);
    }

    const sendMessage=(type='message',fileUrl ='')=>{
        if(!messageBox && type === 'message') return;
        socket.emit("sendMessage",{
            "lead_id":leadId,
            "message":messageBox || fileUrl,
            "user_id":logInUserInfo?.id,
            "source":"web",
            "name":logInUserInfo?.name,
            "type": type,
        })
        setMessageBOx("");
    }

    const inputChange=(e)=>{
        setMessageBOx(e?.target?.value)
    }

    const closeChatBox=()=>{
        document.getElementById('chat-app-outer').style.display = 'none';
        setIsConnected(false);
        if (socket) {
          socket.emit('leaveRoom', { lead_id: leadId, user_id: logInUserInfo?.id });
          socket.disconnect();
          console.log('Disconnected from Socket.IO server');
        }
    }

    const markClosed=async ()=>{
      if(window.confirm("Are you sure ?")){
      setLoading(true);
        const response = await axios.post(`${CHAT_API_URL.CHAT_URL}api/open-close-ticket`, {
            "lead_id":leadId,
            "action_type":"close",
            "user_id":logInUserInfo?.id,
            "source":"web",
            "name":logInUserInfo?.name
        },headers);
        if(response?.data?.message){
            socket.emit("getChatMessages",{lead_id: leadId, page_num:1,source: "web"});
        }
        setLoading(false);
      }
    }

    const getLeadDetails = async (lead_id) => {
      setLoading(true);
      executeGraphQLQuery(LEAD_DETAIL_QUERY(lead_id),{}, client)
      .then((res) => {
      if(res?.data){
          let data = res.data.lead_detail;
          setLeadDetailsData({...data});
          document.getElementById('chat-app-outer').style.display = 'flex';
          setLoading(false);
          var objDiv = document.getElementById("chat-history");
          objDiv.scrollTop = objDiv.scrollHeight;
      }else{
          toast.error("Something went wrong")
          setLoading(false);
      }
      })
      .catch((error) => {
          toast.error(error.toString().replace('ApolloError:',''));
          console.error(error);
          setLoading(false);
      });
  }

  const handleUpload = useCallback(async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, application/pdf";

    input.onchange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("upload_type", "dif_docs");
            formData.append("lead_id", leadId);
            formData.append("images", file);

            const response = await GeneralService.uploadFilesToS3(formData, {
                "Content-Type": "multipart/form-data",
            });

            if (response?.data?.status === 200) {
                const uploadedFile = response.data.data[0];
                if (uploadedFile && uploadedFile !== "not_updated") {
                    sendMessage("file",uploadedFile.file_url);
                }
            } else {
                throw new Error(response?.data?.message || "Upload failed");
            }
        } catch (error) {
            toast.error(error.message || "Upload failed");
        } finally {
            setLoading(false);
        }
    };

    input.click();
  }, [leadId, sendMessage]);

const handleFileDownload = async (url) => {
    try {
        const urlPath = url.split("?")[0];
        const fileName = urlPath.split("/").pop();

        const response = await fetch(url);
        if (!response.ok) throw new Error("Download failed");

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName || "download.file";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        toast.error("Failed to download file");
    }
};

const FileMessage = ({ content }) => {
    const urlPath = content.split("?")[0];
    const fileName = urlPath.split("/").pop();
    const fileExtension = fileName.split(".").pop().toLowerCase();
    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension);

    return (
        <div className="file-message-container">
            <div className="verfication-img">
                {isImage ? (
                  <a href={content} target="_blank" rel="noopener noreferrer">
                    <img src={content} alt="Shared file" />
                  </a>
                ) : (
                  <div className="pdf-gallery">
                    <a href={content} target="_blank" rel="noopener noreferrer">
                      <i className="ic-pdf pdf-font-size"></i>
                    </a>
                  </div>
                )}
            </div>
            <div className="download-btn" onClick={() => handleFileDownload(content)}>
                <i className="ic-save_alt"></i> Download File
            </div>
        </div>
    );
};

const MessageContent = ({ message }) => {
    return message.type === "file" ? <FileMessage content={message.message} /> : <div className="chat-text">{message.message}</div>;
};

const callFilterReset = () => {
  delete filterData.refinance_status;
  setOffset(0);
}

const submitFilterForm = (filterData) => {
  setFilterData(filterData);
  setOffset(0);
  getChatList(1,{...filterData});
}

  return (
    <div className='container-fluid' >
            {loading ? <Loader /> : ''}
            <div>
                <div className='top-heading'>
                    <h2>Chat List</h2>
                </div>

                <div className="loan-filter-bg sfa-chat-top-filter">
                <div className="top-filter-bg">
                  <LeadListFilter
                    filter_data={filterData}
                    loading={loading}
                    onSubmitFilter={submitFilterForm}
                    statusOption={statusOption}
                    callFilterReset={callFilterReset}    
                    isConnected={isConnected}       
                  />
                </div>
              </div>

              
                    <div className="lead-list-data-table inventory-funding-list-table chat-tabel-outer" key={"bpkp"}>
                    <div className='chat-table-data'>
                        <table key={chatdata}>
                            <thead>
                                <tr>
                                    <th >Loan Id</th>
                                    <th>SFA User</th>
                                    <th>Submitted On</th>
                                    <th>Last Message On</th>
                                    <th>Last Replied By</th>
                                    <th>Latest Message</th>
                                    <th>Status</th>
                                    {IS_USER_ACCESS_PAGE('ops_messenger','ops_messenger')?.is_edit_access &&
                                    <th>Action</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                { chatdata && chatdata?.length>0 && chatdata?.map((ch)=>{
                                
                                    return(<tr>
                                        <td>{ch?.lead_id}</td>
                                        <td>{ch?.created_by_name}</td>
                                        <td>{moment(ch?.created_date).format("DD MMM YYYY")}</td>
                                        <td>{ch?.last_message_date ? moment(ch?.last_message_date).format("DD MMM YYYY HH:MM A") : '-'}</td>
                                        <td>{ch?.last_reply_by}</td>
                                        <td style={{"word-break": 'break-all',
    "overflow-wrap": 'break-word'}}>{ch?.message?.includes('http') ? 'File' : ch?.message}</td>
                                        <td>{ +ch?.is_read===0 ? 'unread' : 'open' }</td>
                                        {IS_USER_ACCESS_PAGE('ops_messenger','ops_messenger')?.is_edit_access &&
                                        <td> <button onClick={()=>connectSocket(ch?.lead_id)} title='chat'><i className="ic-remove_red_eyevisibility"></i></button></td>
                                        }
                                    </tr>)
                                })
                                }
                           
                            </tbody>
                        </table>
                        </div>

                <div className='pagination-bx' id="dealerList">
                    <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil(pageCount / 10)}
                        marginPagesDisplayed={2}
                        forcePage = {offset}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div >


                    
            </div>
            </div>

            <div className="chat-app-outer" id='chat-app-outer' style={{ display : 'none'}}>
        
          <div className="chatbox-main">
            <div className="chat-header">
              <div className="header-left">
              <h3>{
                  `${leadDetails?.make} ${leadDetails?.model} ${leadDetails?.variant || leadDetails?.other_mmv}` 
                }</h3>
              <span>{ leadDetails?.dealer_name} ({`GCD`+leadDetails?.dealer_id})</span>
              </div>
              <div className="header-right">
              { ticketData && ticketData?.status==='1' &&
                <button className="resolved-tag-1" onClick={markClosed}>
                  Mark Resolved
                </button>
              }
              { ticketData && ticketData?.status==='2' &&
                <span className="resolved-tag-1">Resolved</span>
              }
                <i className="ic-clearclose" onClick={closeChatBox}></i>
              </div>
            </div>

            <div className="chat-history" id="chat-history">
              <ul>
                { messages && messages?.length>0 && messages?.map((msg)=>{
                  if(msg?.source!=="web"){
                    return(<li className="chat-left">
                    <MessageContent message={msg}/>
                    <span className="chat-time">{moment(msg?.created_date).format("DD MMM YYYY HH:MM A")}</span>
                    </li>)
                  }else{
                    return(<li className="chat-right">
                    <MessageContent message={msg}/>
                    <span className="chat-time">{msg?.name} {moment(msg?.created_date).format("DD MMM YYYY HH:MM A")}</span>
                   
                    </li>)
                  }
                })}
                
                {/* <li className="chat-left">
                  <div className="chat-text">
                  Why this is under incomplete?
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                </li>

                <li className="chat-right">
                  <div className="chat-text">
                  Dealer asking amount is higher then offering amount. So we have sent it for AM approval.
                  <img className="read-icn" src={ReadIcn} />
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                 
                </li>

                <li className="chat-left">
                  <div className="chat-text">
                  Okay
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                </li>

                <li className="chat-right">
                  <div className="chat-text">
                  Anything else I can help you?
                  <img className="read-icn" src={ReadIcn} />
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                </li>
                <li className="reopened-chat">
                  <div className="reopened-txt">It is reopened</div>
                </li>

                <li className="chat-right">
                  <div className="chat-text">
                  It is taking a little time. Will update you once approved.
                  <img className="read-icn" src={ReadIcn} />
                  </div>
                  <span className="chat-time">12 minutes ago</span>
                </li> */}
              </ul>
            </div>

            {/* <div className="defaut-msg">
              <span>Hi</span>
              <span>Ok, Thanks</span>
            </div> */}
            { ticketData && ticketData?.status==='1' &&
            <div className="chat-msg-box">
              <input type="text" className="form-input" value={messageBox} onChange={(e)=>inputChange(e)} placeholder="Say Something" />

              <div className="chat-send-btn m-xs-r" onClick={handleUpload}>
                <i className="ic-attach_file"></i>
              </div>
              <div className="chat-send-btn" onClick={()=>sendMessage()}>
                <i className="ic-keyboard_arrow_right"></i>
              </div>
            </div>
          }
          
        </div>
      </div>
        </div>
  )
}
